import React from 'react';

// ...existing code... (removed unused Container import)
import PushNotifications from 'Components/Partials/PushNotifications';
// import SupportTicketButton from 'Components/Networking/SupportTicketButton';

import Header from './Header';

export default class Authenticated extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const { children, pageTitle, headerImage, titleText, pageVideoHeader = null, showRegBanner = true } = this.props;

        return (
            <div className="min-h-screen flex flex-col bg-app-white">
                <Header pageTitle={pageTitle} headerImage={headerImage} titleText={titleText} pageVideoHeader={pageVideoHeader} showRegBanner={showRegBanner} />

                {/*{window.base.features.support_tickets && <SupportTicketButton/>}*/}

                {window.base.features.allow_push_notifications && <PushNotifications />}

                <div className="flex-1">
                    {children}
                </div>

                <footer className="bg-gray-100 border-t border-gray-200 h-12 md:h-24 flex items-center">
                    <div className="w-full text-center text-xs text-gray-500">© {new Date().getFullYear()} Bupa Symposium</div>
                </footer>
            </div>
        )
    };
}
